import { useState, useEffect } from 'react';

export function useResponsiveFOV() {
  const [fov, setFOV] = useState(40);

  useEffect(() => {
    const updateFOV = () => {
      const width = window.innerWidth;
      
      // Desktop (>1024px): Default FOV
      // Tablet (768px-1024px): Slightly wider FOV
      // Mobile (<768px): Widest FOV to show more of the model
      if (width > 1024) {
        setFOV(42); // Desktop
      } else if (width >= 768) {
        setFOV(44); // Tablet
      } else {
        setFOV(46); // Mobile
      }
    };

    // Initial FOV setup
    updateFOV();

    // Update FOV on resize
    window.addEventListener('resize', updateFOV);
    return () => window.removeEventListener('resize', updateFOV);
  }, []);

  return fov;
} 